import { MyEvents } from "./MyEvents";
import { accountOpen } from "../../profile/account";
import { T } from "../../shared/config";
import { Icon } from "../../shared/icons";
import { closeSheet } from "../../state/view";
import styles from "./profile.module.css";
import { ProfilePanel } from "./ProfilePanel";

/** The side panel / sheet body for My events or Profile; logged out (public mode), the "Coming soon: sign-in" note. */
export function ProfileSheet({ kind }: { kind: "myevents" | "profile" }) {
  // My events and Profile go through the account check by what they show: logged out, the note.
  if (!accountOpen()) {
    return (
      <div id={kind === "myevents" ? "my-events" : "profile"}>
        <div className={styles["list-head"]}><h3>{T(kind === "myevents" ? "myEvents" : "profile")}</h3>
          <button type="button" className={styles["close"]} aria-label={T("close")} onClick={closeSheet}><Icon name="x" /></button></div>
        <p className="muted" id="sign-in-note">{T("account.comingSoon")}</p>
      </div>
    );
  }
  return kind === "myevents" ? <MyEvents /> : <ProfilePanel />;
}
